/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x3369db from'./../../message.js';class GetUserMessage extends _0x3369db{constructor(_0x2fd70a){super(),this['id']=_0x2fd70a;}['toJSON'](){return{'id':this['id']};}static['fromJSON'](_0x385428){return new GetUserMessage(_0x385428['id']);}}GetUserMessage['TYPE']='21',GetUserMessage['READABLE_TYPE_NAME']='getUser',GetUserMessage['DESCRIPTOR_NAME']='GetUserMessage',GetUserMessage['DESCRIPTOR']={'fields':{'id':{'type':'string','id':0x1}}};export default GetUserMessage;